import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  FormControl,
  FormRecord,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AudioAsset } from '@models/Sessions/Idea/AudioProject';
import { formatISO9075 } from 'date-fns/formatISO9075';
import { isAfter } from 'date-fns/isAfter';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';

import { AudioAssetComponent } from '../audio-asset/audio-asset.component';

interface AudioAssetOption {
  name: string;
  index: number;
  control: FormControl<AudioAsset>;
}

@Component({
  selector: 'app-audio-assets',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputGroupModule,
    InputGroupAddonModule,
    ButtonModule,
    SelectModule,
    AudioAssetComponent,
  ],
  templateUrl: './audio-assets.component.html',
  styleUrl: './audio-assets.component.scss',
})
export class AudioAssetsComponent implements OnChanges {
  @Input() assets: FormRecord<FormControl<AudioAsset>>;

  options: AudioAssetOption[] = [];
  selectedAsset: AudioAssetOption | undefined = undefined;

  ngOnChanges(changes: SimpleChanges): void {
    const assets: FormRecord<FormControl<AudioAsset>> =
      changes.assets.currentValue;
    assets.valueChanges.subscribe(() => {
      this.onAfterChanges(assets);
    });
    this.onAfterChanges(assets);
  }

  private onAfterChanges(assets: FormRecord<FormControl<AudioAsset>>) {
    this.options = Object.values(assets.controls)
      .sort((a, b) => {
        if (a.value.createdAt === b.value.createdAt) {
          return 0;
        }
        if (isAfter(b.value.createdAt, a.value.createdAt)) {
          return -1;
        }
        return 1;
      })
      .map((control, index) => {
        return {
          name: formatISO9075(new Date(control.value.createdAt)),
          index,
          control,
        };
      });

    this.selectedAsset = this.options.at(-1);
  }
}
